// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"13":"c31ca7db","788":"3d6ee45f"}[chunkId] + ".css";
};